import Content from '@layout/Content'
import WindTunnelStudyForm from './WindTunnelStudyForm'
import WindTunnelStudyResult from './WindTunnelStudyResult'
import { WindTunnelStudyProvider } from './context'

function WindTunnelStudyPage () {
  return (
    <WindTunnelStudyProvider>
      <Content
        renderInput={<WindTunnelStudyForm />}
        renderOutput={<WindTunnelStudyResult />}
      />
    </WindTunnelStudyProvider>
  )
}

export default WindTunnelStudyPage
